import { InvitationStatusText, UserInvitationStatus } from '../../../../constants/Enums';

const GetBulkActionProps = (bulkActionSelectionHandler, isBulkApproveDisabled, isBulkReinviteDisabled, isBulkActionsDisabled) => {
  return {
    items: [
      {
        dataLwtId: 'bulk-agent-invite-approve-item1',
        itemText: InvitationStatusText.APPROVE,
        key: 'item_1',
        disabled: isBulkApproveDisabled,
        onClick:() => bulkActionSelectionHandler(InvitationStatusText.APPROVE)
      },
      {
        dataLwtId: 'bulk-agent-reinvite-item2',
        itemText: InvitationStatusText.REINVITE,
        key: 'item_2',
        disabled: isBulkReinviteDisabled,
        onClick:() => bulkActionSelectionHandler(InvitationStatusText.REINVITE)
      },
    ],
    toggleProps: {
      dataLwtId: 'bulk-actions-toggle',
      id: 'caret',
      color: 'secondary',
      caret: true,
      children: 'BULK ACTIONS',
      "aria-haspopup": true,
      "aria-expanded": false,
      disabled: isBulkActionsDisabled
    },
    menuProps: {
      dataLwtId: 'bulk-actions-menu'
    }
  };
};

export { GetBulkActionProps };
